import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import { categories } from "@/mocks/events";

export default function Featured() {
  const feats = [events[4], events[8], events[3]];

  return (
    <section className="bg-background-100/70">
      <div className="container-x py-12 md:py-16">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-600">
            <i className="ri-focus-3-line"></i>
            精选专题
          </span>
          <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            本周必看专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            甄选近期热度与讨论度最高的事件，深度梳理来龙去脉，一次看明白。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-3">
          {feats.map((item) => {
            const cat = categories.find((c) => c.key === item.category);
            return (
              <Link
                key={item.id}
                to={`/event/${item.id}`}
                className="group card relative flex flex-col overflow-hidden transition-colors hover:border-primary-300"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    title={`${item.title} 专题视频`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                    <i className={`${cat?.icon} text-xs`}></i>
                    {cat?.label}
                  </span>
                  <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 text-sm font-semibold text-background-50">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-video-line"></i>
                      {item.videoCount} 条视频
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {item.date}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}